import { createClient } from '@supabase/supabase-js'
import { requiredEnvValue } from './env'

// Trimmed via env.ts. The anon key becomes an `apikey:` HEADER, and unlike a URL
// a header value is not whitespace-normalised by anything downstream — a stray
// character in the Vercel variable is a 401 with nothing on screen to explain it.
const supabaseUrl = requiredEnvValue(process.env.EXPO_PUBLIC_SUPABASE_URL)
const supabaseAnonKey = requiredEnvValue(process.env.EXPO_PUBLIC_SUPABASE_ANON_KEY)

// Was an expo-secure-store adapter with a Platform.OS === 'web' branch to
// localStorage. Native is gone, so only the web branch survives — same storage,
// same keys, so sessions signed in before the migration carry over untouched.
const localStorageAdapter = {
  getItem: (key: string) => (typeof localStorage !== 'undefined' ? localStorage.getItem(key) : null),
  setItem: (key: string, value: string) => {
    if (typeof localStorage !== 'undefined') localStorage.setItem(key, value)
  },
  removeItem: (key: string) => {
    if (typeof localStorage !== 'undefined') localStorage.removeItem(key)
  },
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    storage: localStorageAdapter,
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    // Implicit flow so magic links work even when opened in a different browser
    // (PKCE requires the code_verifier from the originating browser's localStorage)
    flowType: 'implicit',
  },
})
